<!-- @veltra/icons generated sha256:d040b45ebd1f271c gen:8 source:src/svg/normal/attach.svg -->
<script setup lang="ts">
defineOptions({ name: 'Attach' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M12.127 3.856a2.017 2.017 0 0 0-2.843.008l-6.851 6.851a.494.494 0 0 1-.702.016l-.021-.021a.494.494 0 0 1 .016-.702l6.85-6.85a3.017 3.017 0 1 1 4.267 4.266l-5.84 5.84A1.884 1.884 0 0 1 4.339 10.6l5.313-5.313a.51.51 0 0 1 .717-.005l.008.008a.497.497 0 0 1-.018.704l-5.313 5.313a.883.883 0 0 0 1.25 1.25l5.84-5.84a2.017 2.017 0 0 0-.01-2.861"
    />
  </svg>
</template>
